/**
 * imageModifiers - Returns URL modifier strings for image URLs based on installation ID
 *
 * Extracted from client ProductForm.tsx (lines 115-132)
 * Determines which image URL modifiers to apply based on the service type.
 *
 * @param installationId - The service ID (e.g., "shopify", "woocommerce")
 * @param isImportedLocal - Whether the product is imported locally
 * @returns Object with modifier and thumbModifier URLs, or undefined if not applicable
 */

const MAX_URL_IMAGE_LONGEST_EDGE = 600;
const THUMBNAIL_SIZE = 200;
const SHOPIFY_URL_MODIFIER = `&height=${MAX_URL_IMAGE_LONGEST_EDGE}&width=${MAX_URL_IMAGE_LONGEST_EDGE}`;
const SHOPIFY_THUMBNAIL_URL_MODIFIER = `&height=${THUMBNAIL_SIZE}&width=${THUMBNAIL_SIZE}`;

type ImageService = "shopify" | "woocommerce";

interface ImageServiceHelpers {
  id: ImageService;
  modifier?: string;
  thumbModifier?: string;
}

const SERVICE_IMAGE_MODIFIERS: { [key in ImageService]: ImageServiceHelpers } = {
  shopify: {
    id: "shopify",
    modifier: SHOPIFY_URL_MODIFIER,
    thumbModifier: SHOPIFY_THUMBNAIL_URL_MODIFIER,
  },
  woocommerce: {
    id: "woocommerce",
  },
};

export interface ImageModifiers {
  modifier: string | undefined;
  thumbModifier: string | undefined;
}

export function imageModifiers(installationId: string, isImportedLocal: boolean): ImageModifiers {
  if (isImportedLocal) {
    return {
      modifier: undefined,
      thumbModifier: undefined,
    };
  }

  if (installationId === "shopify" || installationId === "woocommerce") {
    return {
      modifier: SERVICE_IMAGE_MODIFIERS[installationId as ImageService].modifier,
      thumbModifier: SERVICE_IMAGE_MODIFIERS[installationId as ImageService].thumbModifier,
    };
  }

  return {
    modifier: undefined,
    thumbModifier: undefined,
  };
}
